<template>
  <div class="datafast-test">
    <h3>🧪 Prueba API DataFast</h3>

    <div class="form-group">
      <label>Contrato ID:</label>
      <input
        v-model="testData.idcontrato"
        type="number"
        placeholder="123"
      >
    </div>

    <div class="form-group">
      <label>Usuario ID:</label>
      <input
        v-model="testData.idusuario"
        type="number"
        placeholder="456"
      >
    </div>

    <div class="form-group">
      <label>Monto:</label>
      <input
        v-model="testData.amount"
        type="number"
        step="0.01"
        placeholder="25.50"
      >
    </div>

    <button
      :disabled="loading"
      class="btn btn-primary"
      @click="testAPI"
    >
      {{ loading ? 'Probando...' : 'Probar API /datafast/reference' }}
    </button>

    <div
      v-if="result"
      class="result"
    >
      <h4>📥 Resultado:</h4>
      <pre>{{ JSON.stringify(result, null, 2) }}</pre>
    </div>

    <div
      v-if="error"
      class="error"
    >
      <h4>❌ Error:</h4>
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'DataFastTest',
    data() {
        return {
            loading: false,
            error: null,
            result: null,
            testData: {
                idcontrato: 123,
                idusuario: 456,
                amount: 25.5,
                items: [
                    {
                        codigo: 'SERV001',
                        detalle: 'Servicio de internet',
                        precio: 25.5,
                        cantidad: 1,
                    },
                ],
            },
        }
    },
    methods: {
        async testAPI() {
            this.loading = true
            this.error = null
            this.result = null

            try {
                const response = await this.$http.post(
                    '/datafast/reference',
                    this.testData
                )
                this.result = response.data
            } catch (error) {
                this.error = error.response?.data?.error || error.message
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped>
.datafast-test {
    max-width: 600px;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.form-group input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.btn {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.result {
    margin-top: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
}

.result pre {
    background-color: white;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
}

.error {
    margin-top: 20px;
    padding: 15px;
    background-color: #f8d7da;
    color: #721c24;
    border-radius: 4px;
}
</style>
